/**
 * AlmadarPostWhyStateMachinesForBusinessSLPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostWhyStateMachinesForBusinessSLPostPage
 */

import { useAlmadarPostWhyStateMachinesForBusinessSLPostPageLogic } from '@/hooks/traits/useAlmadarPostWhyStateMachinesForBusinessSLPostPageLogic';
import type { AlmadarPostWhyStateMachinesForBusinessSLPostPageConfig } from '@/hooks/traits/useAlmadarPostWhyStateMachinesForBusinessSLPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostWhyStateMachinesForBusinessSLPostView as AlmadarPostWhyStateMachinesForBusinessSLPostViewEntity } from '@app/shared';
import { AlmadarPostWhyStateMachinesForBusinessSLPostFooterView } from '@/components/traits/AlmadarPostWhyStateMachinesForBusinessSLPostFooterView';
import { AlmadarPostWhyStateMachinesForBusinessSLPostView } from '@/components/traits/AlmadarPostWhyStateMachinesForBusinessSLPostView';
import { Box } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { AlmadarPostWhyStateMachinesForBusinessSLPostHeaderView } from '@/components/traits/AlmadarPostWhyStateMachinesForBusinessSLPostHeaderView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostWhyStateMachinesForBusinessSLPostPageViewProps {
  config?: Partial<AlmadarPostWhyStateMachinesForBusinessSLPostPageConfig>;
}

export function AlmadarPostWhyStateMachinesForBusinessSLPostPageView({ config: propsConfig }: AlmadarPostWhyStateMachinesForBusinessSLPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostWhyStateMachinesForBusinessSLPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostWhyStateMachinesForBusinessSLPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostWhyStateMachinesForBusinessSL" trait="AlmadarPostWhyStateMachinesForBusinessSLPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostWhyStateMachinesForBusinessSLPostPage">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><AlmadarPostWhyStateMachinesForBusinessSLPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box fullWidth={true} paddingY="xl" bg="transparent"><Container size="xl" padding="lg" maxWidth="xl"><AlmadarPostWhyStateMachinesForBusinessSLPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostWhyStateMachinesForBusinessSLPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostWhyStateMachinesForBusinessSLPostPageView;
